import { writable } from "svelte/store";

/**
 * A store that keeps track of whether to show header even if scrolled down.
 */
export const showHeaderStore = writable(false);
